import "./ProductList.scss"
import React, { Component } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import { productStore } from "../../stores"
import { AppHeader, AppPanel, Button, Icon } from "../../lib"
import ProductItem from "./ProductItem"

class ProductList extends Component {
  render() {
    const { products, loading, error } = productStore
    return (
      <div className="ProductList">
        <AppHeader>
          <div className="ProductList_header">
            <h1>Your Products</h1>
            <Button styleName="inverted" to={`/products/add`}>
              Add a product
            </Button>
          </div>
        </AppHeader>
        <AppPanel>
          {products.values().length ? (
            <ul>
              {products
                .values()
                .reverse()
                .map(product => (
                  <li key={product.id}>
                    <ProductItem product={product} />
                  </li>
                ))}
            </ul>
          ) : loading ? (
            <span>Loading...</span>
          ) : error ? (
            <span>An unexpected error occurred.</span>
          ) : (
            <div style={{ paddingTop: 50, textAlign: "center" }}>
              <p style={{ paddingBottom: 20 }}>
                You haven't created any products yet.
              </p>
              <Link to={`/products/add`}>
                <button
                  className="button Button-submit"
                  style={{ width: 250, margin: "0 auto" }}>
                  Create your first product!&nbsp;&nbsp;&nbsp;
                  <Icon name="forward" size={12} color="#fff" />
                </button>
              </Link>
            </div>
          )}
        </AppPanel>
      </div>
    )
  }
}

ProductList.displayName = "ProductList"

export default observer(ProductList)



// WEBPACK FOOTER //
// ./src/products/list/ProductList.js